export default "__VITE_PUBLIC_ASSET__0cf44fcc__"